import { useMemo, useState } from 'react';
import { FileDown } from 'lucide-react';
import { Button } from '@/ui/base/button';
import { designSystemSections } from './sectionRegistry';
import { DOC_VERSION } from './print/printDoc';
import { DocumentoImpresso } from './print/DocumentoImpresso';
import { montarSecoesDoDocumento } from './print/secoesDoDocumento';

/**
 * Ação do documento: abre o documento impresso do Design System — capa,
 * sumário, as seções do mesmo registro que a tela usa (`designSystemSections`)
 * e as páginas de tema — em folhas A4, para imprimir ou salvar como PDF pelo
 * próprio navegador. Nada sobe para lugar nenhum.
 */
export function DesignSystemPdfActions() {
  const [aberto, setAberto] = useState(false);
  const [paginas, setPaginas] = useState<number | null>(null);
  const secoes = useMemo(
    () => (aberto ? montarSecoesDoDocumento(designSystemSections) : []),
    [aberto],
  );

  return (
    <div className="flex flex-col items-start gap-1.5 xl:items-end">
      <Button variant="outline" onClick={() => setAberto(true)} aria-haspopup="dialog">
        <FileDown className="h-4 w-4 mr-1.5" aria-hidden="true" />
        Baixar PDF
      </Button>
      <span className="text-xs text-muted-foreground">
        {DOC_VERSION} · {designSystemSections.length} seções
        {paginas !== null && ` · ${paginas} páginas`}
      </span>
      {aberto && (
        <DocumentoImpresso
          secoes={secoes}
          aoFechar={() => setAberto(false)}
          aoPaginar={setPaginas}
        />
      )}
    </div>
  );
}
